'use strict';
const angular = require('angular');

export default angular.module('appApp.tabmodal', [])
  .directive('tabmodal', function() {
    return {
      template: require('./tabmodal.html'),
      restrict: 'EA',
      scope: {
        tabmodalContent: '='
      },
      link: function(scope, element, attrs) {
      }
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/directives/tabmodal/tabmodal.directive.js